import { ApolloProvider } from '@apollo/client';
import { FC, ReactNode } from 'react';
import { client } from 'src/services/graphql/apollo/client';

const GraphqlProvider: FC<{ children: ReactNode }> = ({ children }) => (
    <ApolloProvider client={client}>{children}</ApolloProvider>
);

export { GraphqlProvider };
